import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { formConstant } from '../../../../config';
import { ConstantService } from 'src/app/core/services/constant.service';
import { IAvailableTypes, IConstantItem } from 'src/app/core/models/available-types.interface';
import { ICountry, IState } from 'src/app/core/models/country.interface';
import { IWarehouseInfo } from 'src/app/modules/customer-management/models/warehouse';
import { CustomerManagementService } from 'src/app/modules/customer-management/services/customer-management.service';
import { RegistrationService } from 'src/app/modules/customer-registration/services/registration.service';
import { UserService } from 'src/app/core/services/user.service';
import { cellPhoneValidator, cellPhoneValidatorNew, landlinePhoneValidator } from 'src/app/core/helpers/helpers.function';
import { CityService } from 'src/app/core/services/city.service';
import { FilterPipe } from '../../pipes/filter.pipe';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { WmsService } from 'src/app/modules/wms/services/wms-service';
import { IWarehouseProviders } from 'src/app/core/models/warehouse-providers';
import { NotificationService } from 'src/app/core/services/notification.service';
import { AddCityPopup } from '../add-city-popup/add-city-popup.component';

@Component({
    selector: 'app-warehouse-popup',
    templateUrl: './warehouse-popup.component.html',
    styleUrls: ['./warehouse-popup.component.scss'],
    providers: [
        FilterPipe
    ]
})
export class WarehousePopupDialog implements OnInit {

    wareHouseForm: FormGroup;
    textFieldMaxLength = formConstant.textFieldMaxLength;

    formConstant = formConstant;
    isThirdPartyIdExist = false;
    phoneCode: any[];
    warehouseProviders: IWarehouseProviders[];
    // locales = LOCATION_TYPES;
    // wareHouseTypes = WAREHOUS_TYPES;
    // counties = COUNTRIES;

    availableTypes: IAvailableTypes;
    ALlcountries: ICountry[];
    Allstates: IState[] = [];
    countries: ICountry[];
    states: IState[] = [];
    cities: any[] = [];
    searchState: FormControl = new FormControl('');
    searchCountry: FormControl = new FormControl('');
    searchCity: FormControl = new FormControl('');
    @Input() info: IWarehouseInfo;
    lastPhoneCode: String = '';
    isProviderRequired = false;
    /** Label of the search placeholder */
    @Input() placeholderLabel = 'Search...';
    @Input() noEntriesFoundLabel = 'No results';

    constructor(
        private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<WarehousePopupDialog>,
        private dialog: MatDialog,
        private constSvc: ConstantService,
        public userSvc: UserService,
        private citySvc: CityService,
        private notify: NotificationService,
        public filterPipe: FilterPipe,
        public wmsService: WmsService
    ) {
    }

    get warehouseTypes(): IConstantItem[] {
        if (!this.availableTypes) {
            return;
        }
        return this.availableTypes.WarehouseType;
    }

    get locales(): IConstantItem[] {
        if (!this.availableTypes) {
            return;
        }
        return this.availableTypes.WarehouseLocation;
    }

    getFlagClass(code: string) {
        return `iti__${code?.toLowerCase()}`;
    }

    ngOnInit(): void {
        this.wareHouseForm = this.initializeForm();
        this.subcribeOnAvailableTypes();
        this.getWarehouseProviders();
        this.wareHouseForm.get('country').setValue(this.info?.address?.state?.country?.code);
        this.constSvc.availablePhoneCodes.subscribe(data => {
            if (!data) {
                return;
            }
            this.phoneCode = data;
        });

        if (this.info?.id) {
            if (this.info.wmsStatus) {
                this.isProviderRequired = true;
                this.wareHouseForm.controls.providerId.setValidators([Validators.required]);
            } else {
                this.isProviderRequired = false;
                this.wareHouseForm.controls.providerId.setValidators([]);
            }
        }

        this.wareHouseForm.get("wmsStatus").valueChanges.subscribe((result) => {
            if (result === 'true') {
                this.isProviderRequired = true;
                this.wareHouseForm.controls.providerId.setValidators([Validators.required]);
                this.wareHouseForm.get('providerId').setValue('');
            } else {
                this.isProviderRequired = false;
                this.wareHouseForm.controls.providerId.setValidators([]);
                this.wareHouseForm.get('providerId').setValue('');
            }
        })

        this.searchCountry.valueChanges.subscribe(value => {
            let searchText = value.toLowerCase();
            this.countries = this.ALlcountries.filter(it => {
                return it.name.toLowerCase().substring(0, searchText.length) == searchText;
            });
        });

        this.searchState.valueChanges.subscribe(value => {
            let searchText = value.toLowerCase();
            this.states = this.Allstates.filter(it => {
                return it.name.toLowerCase().substring(0, searchText.length) == searchText;
            });
        });


        this.wareHouseForm.get('thirdPartyId').valueChanges.pipe(
            debounceTime(1000),
            distinctUntilChanged())
            .subscribe(data => {
                if (this.info?.id) {
                    if (data && this.info?.thirdPartyId !== data) {
                        this.checkThirdPartyIdExist(data);
                    } else {
                        this.isThirdPartyIdExist = false;
                    }
                }
                else {
                    this.checkThirdPartyIdExist(data);
                }
            });
    }

    getWarehouseProviders() {
        this.wmsService.getWarehouseProviders().subscribe(result => {
            this.warehouseProviders = result;
            console.log(this.warehouseProviders);
        });
    }

    checkThirdPartyIdExist(data) {
        this.wmsService.checkThirdPartyIdTaken(data).subscribe((result) => {
            if (result) {
                this.isThirdPartyIdExist = true;
            } else {
                this.isThirdPartyIdExist = false;
            }
        });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        if (this.wareHouseForm.invalid) {
            return;
        }

        this.dialogRef.close(this.model);
    }

    initializeForm(): FormGroup {
        this.getCitiesByCountryId(this.info?.address?.state?.country?.id);
        return this.formBuilder.group({
            name: [this.info?.name || '', [Validators.required, Validators.maxLength(this.textFieldMaxLength)]],
            address: [this.info?.address?.name || '', [Validators.required, Validators.maxLength(this.textFieldMaxLength)]],
            zipCode: [this.info?.address?.zipCode || '', [Validators.required, Validators.maxLength(this.textFieldMaxLength), Validators.minLength(formConstant.minZipCodeLength)]],
            city: [this.info?.address?.city || null, [Validators.required]],
            country: [this.info?.address?.state?.country?.code || null, [Validators.required]],
            state: [this.info?.address?.stateId || null],
            contact1Name: [this.info?.contact1Name || '', [Validators.required, Validators.maxLength(this.textFieldMaxLength)]],
            contact1CellNo: [this.info?.contact1CelNo || '', [cellPhoneValidatorNew()]],
            wmsStatus: [this.info?.id ? (this.info?.wmsStatus ? "true" : "false") : null, [Validators.required]],
            thirdPartyId: [this.info?.thirdPartyId || null],
            providerId: [this.info?.providerId || ''],
        });
    }

    subcribeOnAvailableTypes(): void {
        this.constSvc.availableTypes.subscribe(data => {
            if (!data) {
                return;
            }
            this.availableTypes = data;
        });

        this.constSvc.availableCountries.subscribe(data => {
            if (data) {
                this.countries = data;
                this.ALlcountries = data;
            }
        });

        this.wareHouseForm.get('country').valueChanges.subscribe(value => {
            // this.wareHouseForm.get('phoneCode').setValue(this.getPhoneCode(value));
            if (this.countries) {
                const selectedCountry = this.countries.find(item => item.code == value);
                let phoneNumWithoutCode = (this.wareHouseForm.get('contact1CellNo').value.split(this.lastPhoneCode || this.info?.address?.state?.country?.phoneCode).join('').split('+').join('') || '');
                if (this.info?.id) {
                    this.wareHouseForm.get('contact1CellNo').setValue(this.info?.contact1CelNo);
                }
                else {
                    this.wareHouseForm.get('contact1CellNo').setValue((selectedCountry?.phoneCode || '') + phoneNumWithoutCode);
                }
                this.getCitiesByCountryId(selectedCountry?.id);
                this.lastPhoneCode = selectedCountry?.phoneCode
            }

            if (value && (value !== 'null' || value !== 'undefined')) {
                this.constSvc.getAvailableStatesById(value).subscribe(states => {
                    if (!states) {
                        return;
                    }
                    this.states = states || [];
                    this.Allstates = this.states;

                    const currentStateId = this.wareHouseForm.get('state').value;
                    const matchingState = this.states.find(el => el.id == currentStateId || el.id == this.info?.address?.stateId);
                    this.wareHouseForm.get('state').setValue(matchingState ? matchingState.id : null);
                });
            }
        });
    }

    getPhoneCode(country): string {
        if (!this.countries) {
            return '';
        }
        const countryInfo = this.countries.find(el => el.code == country);
        return countryInfo ? countryInfo?.phoneCode : '';
    }

    get model(): IWarehouseInfo {
        return {
            // companyId: this.regSvc.currentcontactableId,
            // location: this.wareHouseForm.get('locale').value,
            name: this.wareHouseForm.get('name').value,
            // warehouseType: this.wareHouseForm.get('wms').value,
            // wms: this.wareHouseForm.get('wms').value,
            wmsStatus: this.wareHouseForm.get('wmsStatus').value === "true" ? true : false,
            thirdPartyId: this.wareHouseForm.get('thirdPartyId').value,
            providerId: Number(this.wareHouseForm.get('providerId').value),
            address: {
                name: this.wareHouseForm.get('address').value,
                city: this.wareHouseForm.get('city').value,
                zipCode: this.wareHouseForm.get('zipCode').value,
                stateId: this.wareHouseForm.get('state').value || null,
                countryCode: this.wareHouseForm.get('country').value,
            },
            contacts: [
                {
                    name: this.wareHouseForm.get('contact1Name').value,
                    cellNumber: this.wareHouseForm.get('contact1CellNo').value,
                    position: 'mock'
                }
            ]
        };
    }

    compareWithFn(listOfItems, selectedItem) {
        return listOfItems && selectedItem && listOfItems.id === selectedItem.id;
    }

    getCitiesByCountryId(countryID: string | number): void {
        if (countryID) {
            this.citySvc.getAllByCountryId(countryID).subscribe(cities => {
                if (!cities) {
                    return;
                }
                this.cities = cities;
                if (!cities) {
                    this.wareHouseForm.get('city').setValue(null);
                    return;
                }
                let st = this.cities.find(el => el.city === this.info?.address?.city);
                this.wareHouseForm.get('city').setValue(st ? st.city : cities[0].city || null);
            });
        }
    }

    addNewCity(countryCode: string): void {
        if (!countryCode) {
            return;
        }
        const countryId = this.countries.find((el) => el.code === countryCode)?.id;
        if (!countryId) {
            return;
        }
        const dialogRef = this.dialog.open(AddCityPopup);

        dialogRef.afterClosed().subscribe((val) => {
            if (!val) {
                return;
            }

            this.citySvc.create(countryId, val).subscribe(
                (res) => {
                    this.notify.showSuccessMessage('City created successfully');
                    this.cities = this.cities || [];
                    this.cities.push(res);
                    this.wareHouseForm.get('city').setValue(res.city);
                },
                (e) => {
                    if (!e?.error) {
                        return;
                    }
                    switch (e.error.message) {
                        case 'CITY.ERRORS.ALREADY_EXIST':
                            this.notify.showError('City Already Exist');
                            break;
                        case 'COUNTRY.ERRORS.NOT_FOUND':
                            this.notify.showError('Country not found');
                            break;
                        default:
                            this.notify.showError(e.error.message);
                    }
                }
            );
        });
    }
}
